import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.about'), href: '/about/' },
    { label: t('footer.contact'), href: '/contact/' },
    { label: t('footer.privacy'), href: '/privacy/' },
    { label: t('footer.terms'), href: '/terms/' },
    { label: t('footer.disclaimer'), href: '#disclaimer' },
    { label: t('footer.editorial'), href: '#' },
  ];

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-6xl mx-auto">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-xl font-bold mb-3">{t('site.name')}</h3>
            <p className="text-sm text-white/60 leading-relaxed">
              {t('site.description')}
            </p>
          </div>

          {/* Links */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4">
              Resources
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-white/60 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Main Site CTA */}
          <div className="md:col-span-1">
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/40 mb-4">
              {t('nav.mainSite')}
            </h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-foreground-900 text-sm font-medium hover:bg-white/90 transition-colors"
            >
              {t('cta.button.main')}
              <i className="ri-external-link-line" />
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div id="disclaimer" className="mt-10 pt-8 border-t border-white/10">
          <p className="text-xs text-white/40 leading-relaxed text-center max-w-3xl mx-auto">
            {t('footer.disclaimerText')}
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-6 text-center">
          <p className="text-xs text-white/30">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}